<div class="flex schedule-container justify-content-end"> 
    <div class="filter">
        <p-calendar [styleClass]="'w-full custom-calendar'" [inline]="true" [showWeek]="true"></p-calendar>
        <div class="pr-5 pl-5 mt-5" style="text-align: left;">
            <span class="title">Bloqueios e feriados:</span>
            <span class="subtitle" pRipple>Bloquear datas</span>
        </div>
        <div class="pr-5 pl-5 mt-5" style="text-align: left;">
            <span class="title">Exceções:</span>
            <span class="subtitle" pRipple>Adicionar exceção</span>
        </div>
        <div class="pr-5 pl-5 mt-5" style="text-align: left;">
            <span class="title">Especialidade:</span>
            <p-dropdown placeholder="Selecione" styleClass="w-full select-custom-sm" optionLabel="descricao" optionValue="id" inputId="especialidade"></p-dropdown>
        </div>
        <div class="pr-5 pl-5 mt-5" style="text-align: left;">
            <span class="title">Unidade:</span>
            <p-dropdown placeholder="Selecione" styleClass="w-full select-custom-sm" optionLabel="descricao" optionValue="id" inputId="unidade"></p-dropdown>
        </div>
        <div class="pr-5 pl-5 mt-5" style="text-align: left;">
            <span class="title">Serviço:</span>
            <p-dropdown placeholder="Selecione" styleClass="w-full select-custom-sm" optionLabel="descricao" optionValue="id" inputId="servico"></p-dropdown>
        </div>

        <div class="pr-5 pl-5 mt-5 w-full" style="text-align: left;">
            <span class="p-input-icon-right w-full">
                <i class="pi pi-search"></i>
                <input type="text" pInputText class="select-custom-sm  w-full" placeholder="Pesquisar profissional" style="height:34.6px"/>
            </span>
        </div>
        <div class="pr-5 pl-5 mt-2">
            <p-tree  [value]="profissionais" selectionMode="checkbox" class="custom-tree w-full md:w-30rem" >
                <ng-template let-node pTemplate="default">
                    <span class="node-content">
                        <span>{{node.label}}</span>
                    </span>
                </ng-template>
            </p-tree>
        </div>
        <div class="pr-5 pl-5 mt-5 w-full" style="text-align: left;">
            <span class="p-input-icon-right w-full">
                <i class="pi pi-search"></i>
                <input type="text" pInputText class="select-custom-sm  w-full" placeholder="Pesquisar exame" style="height:34.6px"/>
            </span>
        </div>
        <div class="pr-5 pl-5 mt-2">
            <p-tree  [value]="exames" selectionMode="checkbox" class="custom-tree w-full md:w-30rem" >
                <ng-template let-node pTemplate="default">
                    <span class="node-content">
                        <span>{{node.label}}</span>
                    </span>
                </ng-template>
            </p-tree>
        </div>
    </div>
    <div class="body">
        <span pRipple class="close-icon" (click)="closeModal()">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M20 20L4 4M20 4L4 20" stroke="#585050" stroke-width="2" stroke-linecap="round"/>
            </svg>
        </span>
        <span class="p-dialog-title">Próximos horários disponíveis</span>
        <div class="schedule-container-item mt-5">
            <div class="schedule-item">
                <div class="title">
                    Segunda-feira, 19 de Fevereiro de 2024
                </div>
                <div class="title-header flex justify-content-between mt-5">
                    <div class="flex">
                        <div class="flex justify-content-center p-3 pt-1">
                            <img style="width:40px;height:40px;border-radius: 50%;" src="assets/avatar/person.png">
                        </div>
                        <div>
                            <div class="name">Fabio Ribeiro</div>
                            <div class="profession">Cardiologista</div>
                            <div class="place">Unidade Barreiro</div>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="time-card" (click)="openModalAgenda()">
                            16:30
                        </div>
                        <div class="time-card" (click)="openModalAgenda()">
                            16:45
                        </div>
                        <div class="time-card" (click)="openModalAgenda()">
                            17:00
                        </div>
                        <div class="time-card" (click)="openModalAgenda()">
                            17:15
                        </div>
                        <div class="time-card" (click)="openModalAgenda()">
                            17:30
                        </div>
                        <div class="time-card" (click)="openModalAgenda()">
                            17:45
                        </div>
                    </div>
                </div>
            </div>
            <div class="mt-4">
                <p-accordion [activeIndex]="0" styleClass="custom-accordion-sm">
                    <p-accordionTab >
                        <p-header class="flex align-items-center">
                            <svg class="mr-2" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_1441_27718)">
                                <path d="M7.9987 1.33203C11.6807 1.33203 14.6654 4.3167 14.6654 7.9987C14.6667 9.74901 13.9797 11.4297 12.7526 12.6778C11.5255 13.9259 9.8568 14.6414 8.10671 14.6698C6.35663 14.6981 4.66559 14.0371 3.3987 12.8294C2.1318 11.6216 1.39069 9.96414 1.33536 8.2147L1.33203 7.9987L1.3347 7.81203C1.43336 4.2167 4.3787 1.33203 7.9987 1.33203ZM7.9987 7.33203H7.33203L7.25403 7.3367C7.092 7.35597 6.94266 7.434 6.83431 7.55601C6.72595 7.67801 6.66611 7.83552 6.66611 7.9987C6.66611 8.16187 6.72595 8.31938 6.83431 8.44139C6.94266 8.56339 7.092 8.64142 7.25403 8.6607L7.33203 8.66536V10.6654L7.3367 10.7434C7.35425 10.8922 7.42142 11.0307 7.52737 11.1367C7.63333 11.2426 7.77189 11.3098 7.9207 11.3274L7.9987 11.332H8.66536L8.74336 11.3274C8.89218 11.3098 9.03074 11.2426 9.13669 11.1367C9.24264 11.0307 9.30982 10.8922 9.32736 10.7434L9.33203 10.6654L9.32736 10.5874C9.31143 10.4514 9.25399 10.3235 9.16286 10.2213C9.07173 10.1191 8.95133 10.0474 8.81803 10.016L8.74336 10.0027L8.66536 9.9987V7.9987L8.6607 7.9207C8.64315 7.77189 8.57598 7.63333 8.47002 7.52737C8.36407 7.42142 8.22551 7.35425 8.0767 7.3367L7.9987 7.33203ZM8.00536 5.33203L7.9207 5.3367C7.75867 5.35597 7.60933 5.434 7.50097 5.55601C7.39262 5.67801 7.33277 5.83552 7.33277 5.9987C7.33277 6.16187 7.39262 6.31938 7.50097 6.44139C7.60933 6.56339 7.75867 6.64142 7.9207 6.6607L7.9987 6.66536L8.08336 6.6607C8.2454 6.64142 8.39474 6.56339 8.50309 6.44139C8.61144 6.31938 8.67129 6.16187 8.67129 5.9987C8.67129 5.83552 8.61144 5.67801 8.50309 5.55601C8.39474 5.434 8.2454 5.35597 8.08336 5.3367L8.00536 5.33203Z" fill="#585050"/>
                                </g>
                                <defs>
                                <clipPath id="clip0_1441_27718">
                                <rect width="16" height="16" fill="white"/>
                                </clipPath>
                                </defs>
                                </svg>
                            <span>Informações</span>
                         </p-header>
                        <p class="m-1">
                            <span class="font-bold">Idade</span> : 16-100 anos  
                        </p>
                        <p class="m-1">
                            <span class="font-bold">Endereço</span> :  (Barreiro) Rua Professor Adolpho Pinheiro Machado, 336 - São Paulo, SP
                        </p>
                        <p class="m-1">
                            <span class="font-bold">Serviços</span> :  Consulta Reumatologista (R$350), Consulta Acompanhamento (R$300), Retorno Consulta (R$0)
                        </p>
                        <p class="m-1">
                            <span class="font-bold">Formação</span> :  Cardiologista Especialista pela Santa Casa de Belo Horizonte
                        </p>
                        <p class="m-1">
                            <span class="font-bold">Observação</span> :  Cardiologista Especialista pela Santa Casa de Belo Horizonte
                        </p>
                    </p-accordionTab>
                </p-accordion>
                <div class="line mt-5 mb-5"></div>
            </div>

            <div class="schedule-item">
                <div class="title">
                    Segunda-feira, 19 de Fevereiro de 2024
                </div>
                <div class="title-header flex justify-content-between mt-5">
                    <div class="flex">
                        <div class="flex justify-content-center p-3 pt-1">
                            <img style="width:40px;height:40px;border-radius: 50%;" src="assets/avatar/person.png">
                        </div>
                        <div>
                            <div class="name">Fabio Ribeiro</div>
                            <div class="profession">Cardiologista</div>
                            <div class="place">Unidade Barreiro</div>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="time-card">
                            16:30
                        </div>
                        <div class="time-card">
                            16:45
                        </div>
                        <div class="time-card">
                            17:00
                        </div>
                        <div class="time-card">
                            17:15
                        </div>
                        <div class="time-card">
                            17:30
                        </div>
                        <div class="time-card">
                            17:45
                        </div>
                    </div>
                </div>
            </div>
            <div class="mt-4">
                <p-accordion styleClass="custom-accordion-sm">
                    <p-accordionTab >
                        <p-header class="flex align-items-center">
                            <svg class="mr-2" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_1441_27718)">
                                <path d="M7.9987 1.33203C11.6807 1.33203 14.6654 4.3167 14.6654 7.9987C14.6667 9.74901 13.9797 11.4297 12.7526 12.6778C11.5255 13.9259 9.8568 14.6414 8.10671 14.6698C6.35663 14.6981 4.66559 14.0371 3.3987 12.8294C2.1318 11.6216 1.39069 9.96414 1.33536 8.2147L1.33203 7.9987L1.3347 7.81203C1.43336 4.2167 4.3787 1.33203 7.9987 1.33203ZM7.9987 7.33203H7.33203L7.25403 7.3367C7.092 7.35597 6.94266 7.434 6.83431 7.55601C6.72595 7.67801 6.66611 7.83552 6.66611 7.9987C6.66611 8.16187 6.72595 8.31938 6.83431 8.44139C6.94266 8.56339 7.092 8.64142 7.25403 8.6607L7.33203 8.66536V10.6654L7.3367 10.7434C7.35425 10.8922 7.42142 11.0307 7.52737 11.1367C7.63333 11.2426 7.77189 11.3098 7.9207 11.3274L7.9987 11.332H8.66536L8.74336 11.3274C8.89218 11.3098 9.03074 11.2426 9.13669 11.1367C9.24264 11.0307 9.30982 10.8922 9.32736 10.7434L9.33203 10.6654L9.32736 10.5874C9.31143 10.4514 9.25399 10.3235 9.16286 10.2213C9.07173 10.1191 8.95133 10.0474 8.81803 10.016L8.74336 10.0027L8.66536 9.9987V7.9987L8.6607 7.9207C8.64315 7.77189 8.57598 7.63333 8.47002 7.52737C8.36407 7.42142 8.22551 7.35425 8.0767 7.3367L7.9987 7.33203ZM8.00536 5.33203L7.9207 5.3367C7.75867 5.35597 7.60933 5.434 7.50097 5.55601C7.39262 5.67801 7.33277 5.83552 7.33277 5.9987C7.33277 6.16187 7.39262 6.31938 7.50097 6.44139C7.60933 6.56339 7.75867 6.64142 7.9207 6.6607L7.9987 6.66536L8.08336 6.6607C8.2454 6.64142 8.39474 6.56339 8.50309 6.44139C8.61144 6.31938 8.67129 6.16187 8.67129 5.9987C8.67129 5.83552 8.61144 5.67801 8.50309 5.55601C8.39474 5.434 8.2454 5.35597 8.08336 5.3367L8.00536 5.33203Z" fill="#585050"/>
                                </g>
                                <defs>
                                <clipPath id="clip0_1441_27718">
                                <rect width="16" height="16" fill="white"/>
                                </clipPath>
                                </defs>
                                </svg>
                            <span>Informações</span>
                         </p-header>
                        <p class="m-1">
                            <span class="font-bold">Idade</span> : 16-100 anos  
                        </p>
                        <p class="m-1">
                            <span class="font-bold">Endereço</span> :  (Barreiro) Rua Professor Adolpho Pinheiro Machado, 336 - São Paulo, SP
                        </p>
                        <p class="m-1">
                            <span class="font-bold">Serviços</span> :  Consulta Reumatologista (R$350), Consulta Acompanhamento (R$300), Retorno Consulta (R$0)
                        </p>
                        <p class="m-1">
                            <span class="font-bold">Formação</span> :  Cardiologista Especialista pela Santa Casa de Belo Horizonte
                        </p>
                        <p class="m-1">
                            <span class="font-bold">Observação</span> :  Cardiologista Especialista pela Santa Casa de Belo Horizonte
                        </p>
                    </p-accordionTab>
                </p-accordion>
                <div class="line mt-5 mb-5"></div>
            </div>

            <div class="schedule-item">
                <div class="title">
                    Segunda-feira, 19 de Fevereiro de 2024
                </div>
                <div class="title-header flex justify-content-between mt-5">
                    <div class="flex">
                        <div class="flex justify-content-center p-3 pt-1">
                            <img style="width:40px;height:40px;border-radius: 50%;" src="assets/avatar/person.png">
                        </div>
                        <div>
                            <div class="name">Fabio Ribeiro</div>
                            <div class="profession">Cardiologista</div>
                            <div class="place">Unidade Barreiro</div>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="time-card">
                            16:30
                        </div>
                        <div class="time-card">
                            16:45
                        </div>
                        <div class="time-card">
                            17:00
                        </div>
                        <div class="time-card">
                            17:15
                        </div>
                        <div class="time-card">
                            17:30
                        </div>
                        <div class="time-card">
                            17:45
                        </div>
                    </div>
                </div>
            </div>
            <div class="mt-4">
                <p-accordion styleClass="custom-accordion-sm">
                    <p-accordionTab >
                        <p-header class="flex align-items-center">
                            <svg class="mr-2" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_1441_27718)">
                                <path d="M7.9987 1.33203C11.6807 1.33203 14.6654 4.3167 14.6654 7.9987C14.6667 9.74901 13.9797 11.4297 12.7526 12.6778C11.5255 13.9259 9.8568 14.6414 8.10671 14.6698C6.35663 14.6981 4.66559 14.0371 3.3987 12.8294C2.1318 11.6216 1.39069 9.96414 1.33536 8.2147L1.33203 7.9987L1.3347 7.81203C1.43336 4.2167 4.3787 1.33203 7.9987 1.33203ZM7.9987 7.33203H7.33203L7.25403 7.3367C7.092 7.35597 6.94266 7.434 6.83431 7.55601C6.72595 7.67801 6.66611 7.83552 6.66611 7.9987C6.66611 8.16187 6.72595 8.31938 6.83431 8.44139C6.94266 8.56339 7.092 8.64142 7.25403 8.6607L7.33203 8.66536V10.6654L7.3367 10.7434C7.35425 10.8922 7.42142 11.0307 7.52737 11.1367C7.63333 11.2426 7.77189 11.3098 7.9207 11.3274L7.9987 11.332H8.66536L8.74336 11.3274C8.89218 11.3098 9.03074 11.2426 9.13669 11.1367C9.24264 11.0307 9.30982 10.8922 9.32736 10.7434L9.33203 10.6654L9.32736 10.5874C9.31143 10.4514 9.25399 10.3235 9.16286 10.2213C9.07173 10.1191 8.95133 10.0474 8.81803 10.016L8.74336 10.0027L8.66536 9.9987V7.9987L8.6607 7.9207C8.64315 7.77189 8.57598 7.63333 8.47002 7.52737C8.36407 7.42142 8.22551 7.35425 8.0767 7.3367L7.9987 7.33203ZM8.00536 5.33203L7.9207 5.3367C7.75867 5.35597 7.60933 5.434 7.50097 5.55601C7.39262 5.67801 7.33277 5.83552 7.33277 5.9987C7.33277 6.16187 7.39262 6.31938 7.50097 6.44139C7.60933 6.56339 7.75867 6.64142 7.9207 6.6607L7.9987 6.66536L8.08336 6.6607C8.2454 6.64142 8.39474 6.56339 8.50309 6.44139C8.61144 6.31938 8.67129 6.16187 8.67129 5.9987C8.67129 5.83552 8.61144 5.67801 8.50309 5.55601C8.39474 5.434 8.2454 5.35597 8.08336 5.3367L8.00536 5.33203Z" fill="#585050"/>
                                </g>
                                <defs>
                                <clipPath id="clip0_1441_27718">
                                <rect width="16" height="16" fill="white"/>
                                </clipPath>
                                </defs>
                                </svg>
                            <span>Informações</span>
                         </p-header>
                        <p class="m-1">
                            <span class="font-bold">Idade</span> : 16-100 anos  
                        </p>
                        <p class="m-1">
                            <span class="font-bold">Endereço</span> :  (Barreiro) Rua Professor Adolpho Pinheiro Machado, 336 - São Paulo, SP
                        </p>
                        <p class="m-1">
                            <span class="font-bold">Serviços</span> :  Consulta Reumatologista (R$350), Consulta Acompanhamento (R$300), Retorno Consulta (R$0)
                        </p>
                        <p class="m-1">
                            <span class="font-bold">Formação</span> :  Cardiologista Especialista pela Santa Casa de Belo Horizonte
                        </p>
                        <p class="m-1">
                            <span class="font-bold">Observação</span> :  Cardiologista Especialista pela Santa Casa de Belo Horizonte
                        </p>
                    </p-accordionTab>
                </p-accordion>
                <div class="line mt-5 mb-5"></div>
            </div>
        </div>
    </div>
</div>

